import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IFile } from '../../../../models/file.model';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';
import { IUser, UserRoles } from '../../../../models/user.model';
import { IUserRole } from '../../../../models/userRoles.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getAllUsers(): Observable<ISibasiHTTPResponse<IUser[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IUser[]>>(`${environment.api_url}/user/admin`);
  }

  createUser(user: IUser): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/admin`, user);
  }

  updateUser(user: IUser, userId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/admin/${userId}/updateUser`, user);
  }

  // deleteUser(userId: string): Observable<ISibasiHTTPResponse<IUser>> {
  //   return this.httpClient.delete<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/admin/${userId}/deleteUser`);
  // }

  deleteUser(userId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/slateforDeletion/${userId}`);
  }

  restoreDeletedUser(userId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/unslateforDeletion/${userId}`);
  }

  getDeletedUsers(): Observable<ISibasiHTTPResponse<IUser[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IUser[]>>(`${environment.api_url}/user/admin/allDeleted`);
  }

  getUserById(userId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.get<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/admin/${userId}`);
  }

  assignUserRole(role: {role: UserRoles}, userId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/admin/${userId}/assignRole`, role);
  }

  unAssignUserRole(role: {role: UserRoles}, userId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/admin/${userId}/removeRole`, role);
  }

  getAllUsersCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.get<ISibasiHTTPResponse<number>>(`${environment.api_url}/user/admin/all/count`);
  }
  getAllSearchedUsersCount(searchParam: string): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.post<ISibasiHTTPResponse<number>>(`${environment.api_url}/user/admin/all/searched`, {searchParam});
  }
  getPaginatedUsers(pagination?: any): Observable<ISibasiHTTPResponse<IUser[]>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<IUser[]>>(`${environment.api_url}/user/admin/all/paginated`, pagination ? pagination : {});
  }
  getUnApprovedUsers(pagination?: any): Observable<ISibasiHTTPResponse<IUser[]>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<IUser[]>>(`${environment.api_url}/user/unApprovedUsers`, pagination ? pagination : {});
  }
  unApprovedUserCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.get<ISibasiHTTPResponse<number>>(`${environment.api_url}/user/unApprovedUserCount`);
  }
  unApprovedSearchedUserCount(searchParam: string): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.post<ISibasiHTTPResponse<number>>(`${environment.api_url}/user/unApprovedSearchedUserCount`, {searchParam});
  }
  getApprovedUsers(pagination?: any): Observable<ISibasiHTTPResponse<IUser[]>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<IUser[]>>(`${environment.api_url}/user/approvedUsers`, pagination ? pagination : {});
  }
  approvedUserCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.get<ISibasiHTTPResponse<number>>(`${environment.api_url}/user/approvedUserCount`);
  }
  approvedSearchedUserCount(searchParam: string): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient.post<ISibasiHTTPResponse<number>>(`${environment.api_url}/user/approvedSearchedUserCount`, {searchParam});
  }

  getAllUserRoles(): Observable<ISibasiHTTPResponse<IUserRole[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IUserRole[]>>(`${environment.api_url}/userRole/all`);
  }

  getAllHardCodedUserRoles(): Observable<ISibasiHTTPResponse<string[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<string[]>>(`${environment.api_url}/user/getAllRoles`);
  }

  createUserRole(userRole: IUserRole): Observable<ISibasiHTTPResponse<IUserRole>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUserRole>>(`${environment.api_url}/userRole`, userRole);
  }

  updateUserRole(userRole: IUserRole, userRoleId: string): Observable<ISibasiHTTPResponse<IUserRole>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUserRole>>(`${environment.api_url}/userRole/update/${userRoleId}`, userRole);
  }

  deleteUserRole(userRoleId: string): Observable<ISibasiHTTPResponse<IUserRole>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IUserRole>>(`${environment.api_url}/userRole/delete/${userRoleId}`);
  }

  getUserRoleById(userRoleId: string): Observable<ISibasiHTTPResponse<IUserRole>> {
    return this.httpClient.get<ISibasiHTTPResponse<IUserRole>>(`${environment.api_url}/userRole/${userRoleId}`);
  }

  getUserProfile(): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.get<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/profile`);
  }

  updateUserProfile(userProfile: IUser): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient.post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/profile`, userProfile);
  }

  setUserDefaultClinic(clinicId: string): Observable<ISibasiHTTPResponse<IUser>> {
    return this.httpClient
    .post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}/user/setAdditionalProperties`, {additionalProperties: {clinic: clinicId }});
  }

  getProfilePictureMetaData(): Observable<ISibasiHTTPResponse<IFile>> {
    return this.httpClient.get<ISibasiHTTPResponse<IFile>>(`${environment.api_url}/user/profilePicture`);
  }
  // adminChangePassword(userId: string): Observable<ISibasiHTTPResponse<IUser>> {
  //   return this.httpClient.post<ISibasiHTTPResponse<IUser>>(`${environment.api_url} /user/admin/${userId}/changePassword`, newPassword);
  // }
  // adminSetUserDefaultClinic(userId: string, clinicId: string): Observable<ISibasiHTTPResponse<IUser>> {
  //   return this.httpClient
  //   .post<ISibasiHTTPResponse<IUser>>(`${environment.api_url}user/admin/${userId}/setAdditionalProperties`, {additionalProperties: {clinic: clinicId }});
  // }
}
